/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { language } from "config";
import { Box } from "@mui/material";
import Material_React_Table from "../components/React_Material_Table/Material_React_Table";

export default function Earningreports() {
  const columns = [
    { header: language.year, accessorKey: "year" },
    { header: language.months, accessorKey: "monthsName" },
    { header: language.Gross_event_cost, accessorKey: "eventCost" },
    { header: language.event_cost_driver_share, accessorKey: "rideCost" },
    { header: language.convenience_fee, accessorKey: "convenienceFee" },
    { header: language.Discounts, accessorKey: "discountAmount" },
    {
      header: language.Profit,
      accessorKey: "profit",
      Cell: ({ row }) =>
        row.original.convenienceFee - row.original.discountAmount,
      enableEditing: false,
    },
  ];

  const [data, setData] = useState([]);
  const earningreportsdata = useSelector((state) => state.earningreportsdata);

  useEffect(() => {
    if (earningreportsdata.Earningreportss) {
      setData(earningreportsdata.Earningreportss);
    }
  }, [earningreportsdata.Earningreportss]);

  return earningreportsdata.loading ? (
    <CircularLoading />
  ) : (
    <Box>
      <Material_React_Table
        title={language.earning_reports}
        data={data}
        columns={columns}
        enableGrouping
        enableRowSelection={false}
        enableEditing={false}
        enableColumnResizing
        userInitialState={{
          columnVisibility: { id: false },
        }}
        exportButton={true}
      />
    </Box>
  );
}
